import React, { Component } from 'react';
import Slider from 'react-slick';

import Product from '../Product';
import UnderlinedText from '../../UnderlinedText';

import './index.css';

export default class Persona extends Component {
	constructor(props) {
		super(props);

		this.handleSliderChange = this.handleSliderChange.bind(this);
	}

	handleSliderChange() {
		console.log('::::::::::: slider changed');
	}

	render() {
		const { active, personaHexColor, personaName, description, personaImageUrl, products, imageCredits, onRestartClick } = this.props;
		const children = personaName.split(/\n/g);
		const slidesToShow = products.length >= 4 ? 4 : products.length;
		const settings = {
			slidesToShow,
			slidesToScroll: slidesToShow,
			infinite: true,
			responsive: [
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		};

		return (
			<div className={`persona ${active ? 'active' : ''}`}>
				<div className="upper-content">
					<div className="copy">
						<div className="you-are">You Are...</div>
						<div className="hero">
							{children.map((child, index) => <UnderlinedText className="title" text={child} colour={'#00ffff'} key={`child-${index}`} />)}
						</div>
						<div className="description">{description}</div>
						<div className="picks desktop">Your Picks <img className="arrow" src="./arrow.png" alt="arrow" /></div>
					</div>
					<img className="image" src={personaImageUrl} alt="persona" />
				</div>
				<div className="title picks mobile">Your Picks <img className="arrow" src="./arrow.png" alt="arrow" /></div>
				<div className="products">
					<div className="arrows">
						<img src="./arrow.svg" className="arrow left" onClick={() => this.slick.slickPrev()} />
						<img src="./arrow.svg" className="arrow right" onClick={() => this.slick.slickNext()} />
					</div>
					{window.innerWidth > 576 ? <div className='carousel' ref={instance => this.carousel = instance}>
						<div className='carousel-inner' ref={instance => this.carouselInner = instance}>
							<Slider {...settings} ref={instance => this.slick = instance} beforeChange={this.handleSliderChange}>
								{products.map(({ productClickUrl, productBrandName, productImageUrl, productName, productPrice }, index) =>
									<Product productClickUrl={productClickUrl} productBrandName={productBrandName} productImageUrl={productImageUrl} productName={productName} productPrice={productPrice} key={`${productName}-${index}`} />)}
							</Slider>
						</div>
					</div> : products.map(({ productClickUrl, productBrandName, productImageUrl, productName, productPrice }, index) =>
						<Product productClickUrl={productClickUrl} productBrandName={productBrandName} productImageUrl={productImageUrl} productName={productName} productPrice={productPrice} key={`${productName}-${index}`} />)}
				</div>
				<div className={`lower-content`}>
					<div className="restart" onClick={onRestartClick}>Start Over</div>
					<div className="info">{imageCredits}</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Results/Persona/index.js